import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import pcAppointments from '../assets/products/pc-appointments.png';
import appBookSpa from '../assets/products/app-book-spa.png';
import pcRetail from '../assets/products/pc-retail.png';
import appBook4time2 from '../assets/products/app-book4time2.png';

const SpaPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page spaPage">
      <Header />
      <div className="page-header">Spa</div>

      <div className="text-blocks">
        <div className="std-text">
          {"Manage all your spa and salon operations \u2013 from scheduling services to managing staff and offering retail items \u2013 with a single solution. Improve the therapist experience, boost spa retail sales, simplify client engagement, and deliver a frictionless appointment process through our booking wizard, providing visibility to service price, duration, comments, setup time, breakdown time, and priority status."}
        </div>
        <div className="std-text">
          {"Our ai-enabled solution helps optimize revenue and provides a conversational AI Concierge\u00a0to fully automate the entire reservation flow in a natural conversation."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="Spa"
          imgSrc={pcAppointments}
          onClick={() => navigate('/solutions/spa')}
        />
        <FeaturedItem
          label="Book"
          imgSrc={appBookSpa}
          onClick={() => navigate('/solutions/book')}
        />
        <FeaturedItem
          label="Book4Time"
          imgSrc={appBook4time2}
          onClick={() => navigate('/solutions/book4time')}
        />
        <FeaturedItem
          label="Retail"
          imgSrc={pcRetail}
          onClick={() => navigate('/solutions/retail')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default SpaPage;
